<template>
  <div class="page">
    <div class="content">
      <iframe
          v-if="permiteVisualizar"
          title="BI Royalties 06-08-2026"
          :src="powerBiUrl"
          frameborder="0"
          allowfullscreen="true">
      </iframe>
      <div class="sem-permissao" v-else-if="!carregandoPermissao">
        Você não tem permissão para visualizar este painel.
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "BiPetroSupply",
  data() {
    return {
      // link de "Publicar na web" do Power BI
      powerBiUrl: 'https://app.powerbi.com/view?r=eyJrIjoiYzg5ZDNlYmQtMTljYi00ZmIyLThjNGQtZmQ2ZWU1YTgwNWQ1IiwidCI6IjI4Y2E5OGE1LWUyNDctNDAzZC05NmY3LWRiYzdjNjM3MGEyYiJ9',
      permiteVisualizar: false,
      carregandoPermissao: true,
    }
  },
  computed: {
    ...mapGetters('auth', ['nivelUsuarioLogado']),
  },
  methods: {
  	async getPermissoes(){
      this.getPermissaoPorItemPerfil("BIPetroSupply.visualizar",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteVisualizar = permissao;
        })
        .finally(() => {
          this.carregandoPermissao = false;
        });
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped>
.page {
  display: flex;
  flex-direction: column;
}

.content {
  flex: 1;
  display: flex;
}

iframe {
  flex: 1;
  width: 100%;
  min-height: 0;
  border: 0;
}

.sem-permissao {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
